export enum FeedbackEntityType {
  VIDEO_SESSION = 'video_session',
  MOBILE_APP_STORE_REVIEW = 'mobile_app_store_review',
  MOBILE_APP_GENERIC_FEEDBACK = 'mobile_app_generic_feedback',
  MOBILE_APP_VIDEO_SESSION = 'mobile_app_video_session',
  NOTE_SUMMARY_PRESENTING_ISSUES = 'note_summary_presenting_issues',
  NOTE_SUMMARY_SESSION = 'note_summary_session',
  CLIENT_INTAKE_SUMMARY = 'client_intake_summary',
  PROVIDER_MESSAGE_DRAFT_CLIENT_INTAKE = 'provider_message_draft_client_intake',
  PROVIDER_MESSAGE_DRAFT_POST_SESSION = 'provider_message_draft_post_session',
  AI_COACH = 'ai_coach',
}

export interface Feedback {
  id?: string
  entity_type: FeedbackEntityType
  entity_id: string
  lyra_id: string
  user_type: string
  feedback_response: FeedbackResponse[]
}
export interface FeedbackResponse {
  id?: string
  feedback_id?: string
  question: string
  answer: string
}
